module.exports = __webpack_public_path__ + "static/media/homepageBg3.065372ee.jpg";